import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd471dd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "generated-quiz-questions" }
const _hoisted_2 = { class: "flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 bg-blue-100 font-bold p-4 rounded-md shadow-md mb-4" }
const _hoisted_3 = { class: "space-y-6" }
const _hoisted_4 = { class: "question-content" }
const _hoisted_5 = { class: "question-title" }
const _hoisted_6 = { class: "space-y-3 mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "flex-1 items-center gap-3"
}
const _hoisted_8 = { class: "item-label" }
const _hoisted_9 = { class: "item-text ml-1" }
const _hoisted_10 = { class: "item-icon" }
const _hoisted_11 = {
  key: 0,
  class: "pi pi-check text-green-600 text-sm"
}
const _hoisted_12 = {
  key: 1,
  class: "pi pi-times text-h-error-400 text-sm"
}
const _hoisted_13 = { class: "flex-1" }
const _hoisted_14 = { class: "item-label" }
const _hoisted_15 = { class: "item-text" }
const _hoisted_16 = { class: "flex justify-end gap-3 pt-2" }
const _hoisted_17 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_18 = { class: "text-lg font-bold w-full text-center" }
const _hoisted_19 = { class: "space-y-4" }
const _hoisted_20 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_21 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_22 = { class: "block text-sm font-medium text-gray-700 mb-2" }
const _hoisted_23 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_24 = { class: "flex items-center justify-between mb-4" }
const _hoisted_25 = { class: "text-base font-medium text-gray-900" }
const _hoisted_26 = { class: "mb-4" }
const _hoisted_27 = { class: "mb-4" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Resposta* ", -1))
const _hoisted_29 = { class: "select-button-group" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Explicação sobre o item* ", -1))
const _hoisted_33 = {
  key: 0,
  class: "flex justify-start"
}
const _hoisted_34 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_35 = { class: "flex items-center gap-3" }
const _hoisted_36 = { class: "relative flex items-center" }
const _hoisted_37 = {
  key: 0,
  class: "pi pi-check check-icon absolute"
}
const _hoisted_38 = { class: "ml-8" }
const _hoisted_39 = { class: "flex justify-end gap-3" }
const _hoisted_40 = { class: "text-lg font-bold w-full text-center" }
const _hoisted_41 = { class: "text-center" }
const _hoisted_42 = { class: "flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Questões Geradas",
            en: "Generated Questions",
          })), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.generatedQuestions.length) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: "Questões", en: "Questions" })), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatedQuestions, (question, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: question.id || index,
          class: "question-card"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(question.prompt), 1),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.itemTOS, (item, itemIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: itemIndex,
                  class: "item-row"
                }, [
                  (question.type === 'TRUE_OR_FALSE')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("i", {
                          class: _normalizeClass([
                    item.correct
                      ? 'pi pi-check text-green-600'
                      : 'pi pi-times text-h-error-400',
                    'mr-2',
                  ])
                        }, null, 2),
                        _createElementVNode("span", _hoisted_8, " Item " + _toDisplayString(_ctx.getItemLabel(itemIndex, question.type)) + ": ", 1),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.answerText), 1)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_10, [
                          (item.correct)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                            : (_openBlock(), _createElementBlock("i", _hoisted_12))
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, " Item " + _toDisplayString(_ctx.getItemLabel(itemIndex, question.type)) + ": ", 1),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(item.answerText), 1)
                        ])
                      ], 64))
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Button, {
                class: "p-button-sm p-button-text question-edit-btn",
                icon: "pi pi-pencil",
                label: _ctx.$t('labels.edit'),
                onClick: ($event: any) => (_ctx.editQuestion(question, index)),
                disabled: _ctx.loadingStates[index] || _ctx.savingQuestion
              }, null, 8, ["label", "onClick", "disabled"]),
              _createVNode(_component_Button, {
                class: "p-button-sm p-button-text p-button-danger",
                icon: "pi pi-trash",
                label: _ctx.$t('labels.delete'),
                onClick: ($event: any) => (_ctx.deleteGeneratedQuestion(question, index)),
                loading: _ctx.loadingStates[index],
                disabled: _ctx.savingQuestion
              }, null, 8, ["label", "onClick", "loading", "disabled"])
            ])
          ])
        ]))
      }), 128))
    ]),
    (_ctx.generatedQuestions.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_EmptyData, {
            data: true,
            label: 
          _ctx.$t('labels.generic', {
            pt: 'Nenhuma questão gerada ainda',
            en: 'No questions generated yet',
          })
        ,
            image: "empty_questions.svg",
            imgSize: "h-24"
          }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.addQuestionModal,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addQuestionModal) = $event)),
      draggable: false,
      breakpoints: { '960px': '95vw', '640px': '95vw' },
      style: { width: '50vw', minWidth: '400px' },
      onHide: _ctx.closeAddQuestionModal,
      modal: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("quiz.teacher.edit")), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createVNode(_component_Button, {
            class: "btn-outline p-button-sm",
            label: _ctx.$t('labels.cancel'),
            onClick: _ctx.closeAddQuestionModal,
            disabled: _ctx.savingQuestion
          }, null, 8, ["label", "onClick", "disabled"]),
          _createVNode(_component_Button, {
            class: "btn-primary p-button-sm",
            label: _ctx.$t('labels.generic', { pt: 'Atualizar', en: 'Update' }),
            onClick: _ctx.saveQuestion,
            loading: _ctx.savingQuestion,
            disabled: !_ctx.isQuestionValid
          }, null, 8, ["label", "onClick", "loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Tipo de questão",
                en: "Question type",
              })), 1),
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.newQuestion.type,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newQuestion.type) = $event)),
              options: _ctx.questionTypeOptions,
              optionLabel: "label",
              optionValue: "value",
              placeholder: "Selecione o tipo",
              class: "w-full",
              disabled: true,
              showClear: false
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("labels.generic", { pt: "Pergunta", en: "Question" })) + " * ", 1),
            _createVNode(_component_Textarea, {
              modelValue: _ctx.newQuestion.prompt,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newQuestion.prompt) = $event)),
              rows: "3",
              class: "w-full",
              placeholder: 
              _ctx.$t('labels.generic', {
                pt: 'Digite sua pergunta aqui',
                en: 'Type your question here',
              })
            
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("labels.generic", { pt: "Alternativas", en: "Alternatives" })), 1),
            (_ctx.newQuestion.type === 'TRUE_OR_FALSE')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newQuestion.itemTOS, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `tf-item-${index}`,
                      class: "border border-gray-200 rounded-lg p-4"
                    }, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("h4", _hoisted_25, " Item " + _toDisplayString(_ctx.getItemLabel(index, _ctx.newQuestion.type)) + "* ", 1),
                        (_ctx.newQuestion.itemTOS.length > 2)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              class: "p-button-sm p-button-outlined p-button-danger",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => (_ctx.removeAlternative(index))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Textarea, {
                          modelValue: item.answerText,
                          "onUpdate:modelValue": ($event: any) => ((item.answerText) = $event),
                          rows: "3",
                          class: "w-full",
                          placeholder: 
                    _ctx.$t('labels.generic', {
                      pt: 'Digite aqui o item da questão',
                      en: 'Enter the question item here',
                    })
                  
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass([
                      'select-button',
                      item.correct === true ? 'active' : 'inactive',
                    ]),
                            onClick: ($event: any) => (_ctx.setTrueFalseAnswer(index, true))
                          }, " Verdadeiro ", 10, _hoisted_30),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass([
                      'select-button',
                      item.correct === false ? 'active' : 'inactive',
                    ]),
                            onClick: ($event: any) => (_ctx.setTrueFalseAnswer(index, false))
                          }, " Falso ", 10, _hoisted_31)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_32,
                        _createVNode(_component_Textarea, {
                          modelValue: item.answerDescription,
                          "onUpdate:modelValue": ($event: any) => ((item.answerDescription) = $event),
                          rows: "3",
                          class: "w-full",
                          placeholder: 
                    _ctx.$t('labels.generic', {
                      pt: 'Digite aqui a explicação sobre o item',
                      en: 'Enter the explanation about the item here',
                    })
                  
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                      ])
                    ]))
                  }), 128)),
                  (_ctx.newQuestion.itemTOS.length < 5)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createVNode(_component_Button, {
                          class: "btn-outline p-button-sm gap-1",
                          icon: "pi pi-plus",
                          label: 
                  _ctx.$t('labels.generic', {
                    pt: 'Criar item',
                    en: 'Create item',
                  })
                ,
                          onClick: _ctx.addAlternative
                        }, null, 8, ["label", "onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newQuestion.itemTOS, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `item-${index}`,
                      class: "space-y-2"
                    }, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_RadioButton, {
                            modelValue: _ctx.correctAnswerIndex,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.correctAnswerIndex) = $event)),
                            inputId: `correct-${index}`,
                            value: index,
                            class: _normalizeClass(
                      _ctx.correctAnswerIndex === index ? 'correct-selected' : ''
                    )
                          }, null, 8, ["modelValue", "inputId", "value", "class"]),
                          (_ctx.correctAnswerIndex === index)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_37))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_InputText, {
                          modelValue: item.answerText,
                          "onUpdate:modelValue": ($event: any) => ((item.answerText) = $event),
                          placeholder: `${_ctx.$t('labels.generic', {
                    pt: 'Alternativa',
                    en: 'Alternative',
                  })} ${_ctx.getItemLabel(index, _ctx.newQuestion.type)}`,
                          class: _normalizeClass([
                    'flex-1',
                    item.correct
                      ? 'border-green-500 focus:border-green-600 focus:ring-green-500'
                      : 'border-gray-300',
                  ])
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "class"])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_Textarea, {
                          modelValue: item.answerDescription,
                          "onUpdate:modelValue": ($event: any) => ((item.answerDescription) = $event),
                          rows: "2",
                          class: "w-full",
                          placeholder: 
                    _ctx.$t('labels.generic', {
                      pt: 'Explicação sobre o item',
                      en: 'Item explanation',
                    })
                  
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
                      ])
                    ]))
                  }), 128))
                ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onHide"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.deleteConfirmModal,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.deleteConfirmModal) = $event)),
      draggable: false,
      style: { width: '400px' },
      modal: ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Confirmar exclusão",
              en: "Confirm deletion",
            })), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_Button, {
            class: "btn-outline p-button-sm",
            label: _ctx.$t('labels.cancel'),
            onClick: _ctx.cancelDelete,
            disabled: _ctx.deletingQuestion
          }, null, 8, ["label", "onClick", "disabled"]),
          _createVNode(_component_Button, {
            class: "btn-primary p-button-sm",
            label: _ctx.$t('labels.delete'),
            onClick: _ctx.confirmDeleteQuestion,
            loading: _ctx.deletingQuestion
          }, null, 8, ["label", "onClick", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t("labels.generic", {
            pt: "Tem certeza que deseja excluir esta questão?",
            en: "Are you sure you want to delete this question?",
          })), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}